<script>
import { mapActions } from 'vuex';
import BaseAutocompleteSearchRequestFilter from '@/modules/_global/_components/filters/BaseAutocompleteSearchRequestFilter.vue';

export default {
  name: 'BusinessCustomersFilter',

  extends: BaseAutocompleteSearchRequestFilter,

  watch: {
    value: {
      deep: true,
      immediate: true,
      handler(v) {
        this.getDataDebounced(v);
      }
    }
  },

  methods: {
    ...mapActions('building_complex', ['getFilteredBusinessCustomers']),

    getData(search) {
      return this.getFilteredBusinessCustomers({ search }).then(({ data }) => {
        return data.data;
      });
    }
  }
};
</script>
